import React, { useState, useEffect, useContext, Fragment } from 'react';
import WaveSurfer from 'wavesurfer.js';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import Replay10Icon from '@mui/icons-material/Replay10';
import Forward10Icon from '@mui/icons-material/Forward10';
import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { IconButton } from '@mui/material';
import { RecordingViewModel } from '../ViewModels/RecordingViewModel';
import { Select } from '@mui/material';
import { MenuItem } from '@mui/material';
import { SelectChangeEvent } from '@mui/material';
import { APIContext } from '../Contexts/APIContext';
import { secondsConversion } from '../Utilities/UtilityMethods';

interface IAudioWaveProps {
    wav: string;
    recordingId?: number;
    isClient: boolean;
    setSelectedCall?: (switchCallId) => void;
    recordings?: RecordingViewModel[];
    selectedCall?: string;
    agentView?: boolean;
    recordingFile: Blob;
}

export default function AudioWave({ wav, recordingId, isClient, recordings, setSelectedCall, selectedCall, agentView, recordingFile }: IAudioWaveProps) {
    const { waveRef, wavesurfer } = useContext(APIContext);
    const [playing, setPlaying] = useState(false);
    const [totalTime, setTotalTime] = useState('00:00:00');
    const [textTime, setTextTime] = useState('00:00:00');
    const [name, setName] = useState('');
    const [downloadDialog, setDownloadDialog] = useState(false);

    useEffect(() => {
        if (isClient) {
            wavesurfer!.current = WaveSurfer.create({
                container: waveRef!.current!,
                waveColor: '#3bb7b2',
                progressColor: '#545a86',
                height: 80
            });
            wavesurfer!.current.loadBlob(recordingFile);
            wavesurfer!.current.on('audioprocess', () => { updateTime(); });
            wavesurfer!.current.on('ready', () => {
                const totTime = wavesurfer!.current!.getDuration();
                const time = secondsConversion(totTime);
                setTotalTime(time);
            });
        }
        else {
            wavesurfer!.current = WaveSurfer.create({
                container: waveRef!.current!,
                waveColor: '#3bb7b2',
                progressColor: '#545a86',
                height: 80
            });
            wavesurfer!.current.loadBlob(recordingFile);
            wavesurfer!.current.on('audioprocess', () => { updateTime(); });
            wavesurfer!.current.on('ready', () => {
                const totTime = wavesurfer!.current!.getDuration();
                const time = secondsConversion(totTime);
                setTotalTime(time);
            });
        }
        return () => wavesurfer!.current!.destroy();
    }, []);

    const onPlayPause = () => {
        if (wavesurfer!.current!.isPlaying()) {
            wavesurfer!.current!.pause();
        } else {
            wavesurfer!.current!.play();
        }

        setPlaying(wavesurfer!.current!.isPlaying());
    }

    const onSkipBackward = () => {
        wavesurfer!.current!.skip(-10);
    }

    const onSkipForward = () => {
        wavesurfer!.current!.skip(10);
    }

    const updateTime = () => {
        const curTime = wavesurfer!.current!.getCurrentTime();
        const time = secondsConversion(curTime);
        setTextTime(time);
    }
    const handleCallChange = (event: SelectChangeEvent) => {
        if (setSelectedCall !== undefined) {
            setSelectedCall(event.target.value);
        }
    };

    //const onRegionCreated = (region) => {
    //    const list = [...notes];

    //    const index = list.findIndex(f => f.id === region.id);

    //    if (index !== -1) {
    //        const change = list[index];
    //        change.endTime = region.end;
    //        change.startTime = region.start;
    //        change.note = region.data.note;
    //        list[index] = change;
    //    } else {
    //        const newId = (Math.random() * 1000);
    //        list.push({
    //            id: newId,
    //            recordingId: recordingId,
    //            startTime: region.start,
    //            endTime: region.end,
    //            note: ""
    //        });
    //        region.id = newId;
    //        region.drag = false;
    //        region.resize = false;
    //        region.update(region);
    //    }

    //    setNotes(list);
    //}

    //const updateRegion = (region: RecordingNoteViewModel) => {
    //    const list = [...notes];
    //    const index = list.findIndex(f => f.id === region.id);
    //    list[index] = region;

    //    setNotes(list);

    //    if (!Number.isInteger(region.id)) {
    //        region.id = 0;
    //    }
    //    const note = JSON.stringify(region);

    //    msalFetch('api/Info/SaveRecordingNote/', {
    //        method: 'POST',
    //        headers: {
    //            'Content-Type': 'application/json; charset=utf-8',
    //        },
    //        body: note
    //    })
    //        .then(response => response.json())
    //        .then(data => {
    //            list[index] = data;
    //            setNotes(list);
    //        });
    //}



    //const loadRegions = () => {
    //    wavesurfer.current.clearRegions();

    //    notes.forEach((note) => {
    //        const region = {
    //            id: note.id,
    //            start: note.startTime,
    //            end: note.endTime,
    //            data: { note: note.note },
    //            drag: false,
    //            resize: false
    //        };
    //        wavesurfer.current.addRegion(region);
    //    });
    //}

    //const removeRegion = (id: number) => {
    //    Object.keys(wavesurfer.current.regions.list).forEach(m => {
    //        if (wavesurfer.current.regions.list[m].id === id) {
    //            wavesurfer.current.regions.list[m].remove();
    //        }
    //    });

    //    const list = notes.slice();
    //    const listIndex = list.findIndex(f => f.id === id);
    //    list.splice(listIndex, 1);

    //    setNotes(list);

    //    msalFetch('api/Info/DeleteRecordingNote?id=' + id);
    //}

    const onNameChange = (e) => setName(e.target.value);
    const openDialog = () => setDownloadDialog(true);

    const closeDialog = () => {
        setDownloadDialog(false);
        setName('');
    }

    const downloadRecording = () => {
        const url = wav;
        const end = url.includes('wav') ? '.wav' : '.mp3';


        const blobUrl = window.URL.createObjectURL(recordingFile);

        const a = document.createElement('a');
        a.download = name + end;
        a.href = blobUrl;
        a.click();

        closeDialog();
    }

    return (
        <Fragment>
            <Grid container alignItems="center" size={12} spacing={0} style={{ width: '100%' }}>
                <Grid size={12}>
                    <div className='waveform'>
                        <div className='wave' ref={waveRef} />
                    </div>
                </Grid>
                <Grid size={12}>
                    <Grid container alignItems="center" spacing={1}>
                        <Grid size={4}>
                            <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: '8px' }}>
                                <Grid >
                                    <Typography>{textTime} / {totalTime}</Typography>
                                </Grid>
                                <Grid >
                                    {recordings &&
                                        <Fragment>{
                                            recordings.length > 1 ?
                                                <Select
                                                    variant="standard"
                                                    labelId="call-select-label"
                                                    id="call-select"
                                                    value={selectedCall === '0' ? recordings[0].switchCallID : selectedCall}
                                                    onChange={handleCallChange}
                                                >
                                                    {recordings.map((item, i) =>
                                                        <MenuItem key={item.switchCallID} value={item.switchCallID}>{'Call ' + (i + 1)}</MenuItem>
                                                    )}
                                                </Select>
                                                :
                                                <React.Fragment />
                                        }
                                        </Fragment>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={4}>
                            <Grid container alignItems="center" justifyItems="centre" justifyContent="center">
                                <Grid>
                                    <IconButton onClick={onSkipBackward} >
                                        <Replay10Icon color="primary" />
                                    </IconButton>
                                </Grid>
                                <Grid>
                                    <IconButton onClick={onPlayPause} >
                                        {playing ? <PauseIcon color="primary" /> : <PlayArrowIcon color="primary" />}
                                    </IconButton>
                                </Grid>
                                <Grid>
                                    <IconButton onClick={onSkipForward} >
                                        <Forward10Icon color="primary" />
                                    </IconButton>
                                </Grid>
                                {
                                    (!agentView) &&
                                    <Grid>
                                        <IconButton onClick={openDialog} >
                                            <SaveAltIcon color="primary" />
                                        </IconButton>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                        <Grid size={4}>
                        </Grid>
                    </Grid>
                </Grid>
                <Dialog open={downloadDialog} onClose={closeDialog}>
                    <DialogContent>
                        <DialogContentText>Choose a name for the downloaded file.</DialogContentText>
                        {!isClient && <DialogContentText>Default is: {wav.split('?')[0]}</DialogContentText>}
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Download Name"
                            fullWidth
                            value={name}
                            onChange={onNameChange}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog} color="primary">Cancel</Button>
                        <Button onClick={downloadRecording} color="primary">Save</Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </Fragment>
    );
}